var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.right_adv.url)?_c('div',{staticClass:"right-box"},[_c('div',{staticClass:"rightTop"},[_c('img',{attrs:{"width":"100%","src":_vm.right_adv.image,"alt":""},on:{"click":function($event){return _vm.rightAdvClick(_vm.right_adv.param, _vm.right_adv.url)}}}),_vm._v(" "),_c('span',[_vm._v("广告")])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-529ee5ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rightadv.vue
// module id = oO6O
// module chunks = 1